var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "headerDiv" } }, [
      _c("div", [
        _c(
          "div",
          { attrs: { id: "headDiv" } },
          [
            _c("v-select", {
              staticStyle: { "min-width": "20vh", "margin-right": "5%" },
              attrs: {
                "item-text": "label",
                "item-value": "value",
                items: _vm.dateOptions,
                "prepend-icon": "event",
                attach: "",
                chips: "",
                label: "Fecha relativa"
              },
              model: {
                value: _vm.dateValue,
                callback: function($$v) {
                  _vm.dateValue = $$v
                },
                expression: "dateValue"
              }
            }),
            _c("v-combobox", {
              staticStyle: { "min-width": "24vh", "margin-right": "5%" },
              attrs: {
                multiple: "",
                "append-icon": "",
                label: "Búsqueda por patentes",
                chips: "",
                "deletable-chips": "",
                "search-input": _vm.search
              },
              on: {
                "update:searchInput": function($event) {
                  _vm.search = $event
                },
                "update:search-input": function($event) {
                  _vm.search = $event
                },
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                  ) {
                    return null
                  }
                  return _vm.updateTags($event)
                }
              },
              model: {
                value: _vm.patentValues,
                callback: function($$v) {
                  _vm.patentValues = $$v
                },
                expression: "patentValues"
              }
            }),
            _c(
              "div",
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "#27488E", fab: "", small: "", dark: "" },
                    on: { click: _vm.filterActivities }
                  },
                  [_c("v-icon", [_vm._v("search")])],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _c(
      "div",
      { attrs: { id: "bodyDiv" } },
      [
        _c(
          "v-layout",
          [
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointAlert = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointAlert = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Alertas")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointAlert,
                                expression: "mousePointAlert"
                              }
                            ],
                            attrs: { type: "alertGraph" },
                            on: {
                              point: function($event) {
                                _vm.mousePointAlert = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("barComp", {
                      ref: "barRefAlert",
                      attrs: { height: 280 }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointAlertDetail = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointAlertDetail = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Alertas Detalle")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointAlertDetail,
                                expression: "mousePointAlertDetail"
                              }
                            ],
                            attrs: { type: "alertGraphDetail" },
                            on: {
                              point: function($event) {
                                _vm.mousePointAlertDetail = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "gridDivClass" },
                      [
                        _c("ag-grid-vue", {
                          staticClass: "ag-theme-material",
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            columnDefs: _vm.columnDefsAlert,
                            rowData: _vm.rowDataAlert,
                            gridOptions: _vm.gridOptionAlert
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-layout",
          [
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointSpeed = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointSpeed = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Velocidad Máxima")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointSpeed,
                                expression: "mousePointSpeed"
                              }
                            ],
                            attrs: { type: "speed" },
                            on: {
                              point: function($event) {
                                _vm.mousePointSpeed = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticStyle: { width: "100%" } },
                      [
                        _c("barComp", {
                          ref: "barRefSpeed",
                          attrs: { height: 280 }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "bottomDateClass" }, [
                      _vm._v("\n            Fecha\n          ")
                    ])
                  ]
                )
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointSpeedDetail = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointSpeedDetail = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Velocidad Máxima Detalle")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointSpeedDetail,
                                expression: "mousePointSpeedDetail"
                              }
                            ],
                            attrs: { type: "speedDetail" },
                            on: {
                              point: function($event) {
                                _vm.mousePointSpeedDetail = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "gridDivClass" },
                      [
                        _c("ag-grid-vue", {
                          staticClass: "ag-theme-material",
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            columnDefs: _vm.columnDefsSpeed,
                            rowData: _vm.rowDataSpeed,
                            gridOptions: _vm.gridOptionSpeed
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-layout",
          [
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointDistance = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointDistance = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Kilómetros Recorridos")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointDistance,
                                expression: "mousePointDistance"
                              }
                            ],
                            attrs: { type: "distance" },
                            on: {
                              point: function($event) {
                                _vm.mousePointDistance = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("barComp", {
                      ref: "barRefDistance",
                      attrs: { height: 280 }
                    }),
                    _c("div", { staticClass: "bottomDateClass" }, [
                      _vm._v("\n            Fecha\n          ")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointDistanceDetail = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointDistanceDetail = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Kilómetros Recorridos Detalle")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointDistanceDetail,
                                expression: "mousePointDistanceDetail"
                              }
                            ],
                            attrs: { type: "distanceDetail" },
                            on: {
                              point: function($event) {
                                _vm.mousePointDistanceDetail = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "gridDivClass" },
                      [
                        _c("ag-grid-vue", {
                          staticClass: "ag-theme-material",
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            columnDefs: _vm.columnDefsDistance,
                            rowData: _vm.rowDataDistance,
                            gridOptions: _vm.gridOptionDistance
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-layout",
          [
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointTime = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointTime = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Tiempo de Uso")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointTime,
                                expression: "mousePointTime"
                              }
                            ],
                            attrs: { type: "useTime" },
                            on: {
                              point: function($event) {
                                _vm.mousePointTime = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("barComp", {
                      ref: "barRefTime",
                      attrs: { height: 280 }
                    }),
                    _c("div", { staticClass: "bottomDateClass" }, [
                      _vm._v("\n            Fecha\n          ")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointTimeDetail = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointTimeDetail = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Tiempo de Uso Detalle")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointTimeDetail,
                                expression: "mousePointTimeDetail"
                              }
                            ],
                            attrs: { type: "useTimeDetail" },
                            on: {
                              point: function($event) {
                                _vm.mousePointTimeDetail = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "gridDivClass" },
                      [
                        _c("ag-grid-vue", {
                          staticClass: "ag-theme-material",
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            columnDefs: _vm.columnDefsTime,
                            rowData: _vm.rowDataTime,
                            gridOptions: _vm.gridOptionTime
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-layout",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ]
          },
          [
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointIgnition = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointIgnition = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Ignición ON / OFF")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointIgnition,
                                expression: "mousePointIgnition"
                              }
                            ],
                            attrs: { type: "ignition" },
                            on: {
                              point: function($event) {
                                _vm.mousePointIgnition = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("lineComp", {
                      ref: "lineRefIgnicion",
                      attrs: { height: 280 }
                    }),
                    _c("div", { staticClass: "bottomDateClass" }, [
                      _vm._v("\n            Fecha\n          ")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointIgnitionDetail = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointIgnitionDetail = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Ignición ON / OFF Detalle")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointIgnitionDetail,
                                expression: "mousePointIgnitionDetail"
                              }
                            ],
                            attrs: { type: "ignitionDetail" },
                            on: {
                              point: function($event) {
                                _vm.mousePointIgnitionDetail = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "gridDivClass" },
                      [
                        _c("ag-grid-vue", {
                          staticClass: "ag-theme-material",
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            columnDefs: _vm.columnDefsIgnition,
                            rowData: _vm.rowDataIgnition,
                            gridOptions: _vm.gridOptionIgnition,
                            suppressCopyRowsToClipboard: "true"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }